import React, {useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header.jsx';           // ваш компонент шапки
import lingonImg from '../images/Брусника_картинка.jpg'; // пример картинки
import '../style/CakeDetail.css';

const CakeDetailLingon = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();

  return (
    <>
      <Header />

      <div className="detail-container">
        <div className="detail-text">
          <h2>Наполеон с брусникой</h2>
          <p>Волшебная ягода, которая добавит кислинку, легкую терпкость и нотку зимней горечи.</p>
          <p><strong>Вес:</strong> 1,4&nbsp;кг</p>
          <p><strong>Цена:</strong> 2300&nbsp;₽</p>
          <button onClick={() => navigate(-1)} className="back-button">
            ← Назад
          </button>
        </div>

        <div className="detail-image">
          <img src={lingonImg} alt="Наполеон Классический" />
        </div>
      </div>
    </>
  );
};

export default CakeDetailLingon;
